export const pageTypes = {
	PSP: 'PSP',
	SGP: 'SGP',
};
